import { Route, Routes } from "react-router-dom";
import { Index } from "./pages/index/Index";
import { Login } from "./pages/login/Login";
import { useAuth } from "./context/AuthContext";
import { useEffect } from "react";
import { Courses } from "./pages/courses/Courses";
import { ProtectedRoutes } from "./components/ProtectedRoutes/ProtectedRoutes";
import { Profile } from "./pages/profile/Profile";
import { CourseView } from "./pages/course_view/CourseView";
import { CoursePlayer } from "./pages/course_player/CoursePlayer";
import { Register } from "./pages/register/Register";
import { ForgotPwd } from "./pages/forgot_pwd/ForgotPwd";
import { PasswordReset } from "./pages/password_reset/PasswordReset";
import { Contact } from "./pages/contact/Contact";
import CheckoutForm from "./components/checkout_form/CheckoutForm";
import Payment from "./pages/payment/Payment";

function App() {
	const {checkAuth} = useAuth();

	useEffect(() => {
		checkAuth();
	}, []);

  	return (
		<>
			<Routes>
				<Route path="/" element={<Index />} />
				<Route path="/contact" element={<Contact />} />
				<Route path="/login" element={<Login />} />
				<Route path="/register" element={<Register />} />
				<Route path="/forgot" element={<ForgotPwd />} />
				<Route path="/password/reset" element={<PasswordReset />} />
				<Route path="/courses" element={<Courses />} />
				<Route path="/course/:id" element={<CourseView />} />
				<Route path="/course/:courseId/article/:ArticleId" element={<CoursePlayer />} />
				<Route path="/payment" element={<Payment />} />
			</Routes>

			<ProtectedRoutes>
				<Route path="/profile" element={<Profile /> } />
			</ProtectedRoutes>
		</>
  	);
}

export default App;
